import { ArrowRight } from 'lucide-react'
import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { CHAT_START_LABEL } from '@/lib/postgraduate-chat/chat-flow'

interface ChatStartCardProps {
  readonly onStart: () => void
}

export function ChatStartCard({ onStart }: ChatStartCardProps) {
  return (
    <div className="shrink-0 border-neutral-200 border-t px-4 py-3">
      <Button className="flex items-center justify-center gap-2" onClick={onStart} type="button">
        {CHAT_START_LABEL}
        <ArrowRight className="size-4" />
      </Button>
      <p className="pt-2 text-center font-rethink text-neutral-500 text-xs">
        Ao continuar você aceita nossa{' '}
        <Link
          className="text-primary-800 underline underline-offset-2"
          href="/politica-de-privacidade"
        >
          Política de Privacidade
        </Link>
        .
      </p>
    </div>
  )
}
